const configuratorRings = {

    settings: {
      limit: 5,
      previousState: [],
      items: [],
    },

    init: () => {

        configuratorRings.modalCloseApp();
        configuratorRings.productEvents();
        configuratorRings.initSwipers();
        configuratorRings.handleAddToCartButton();
        configuratorRings.mobileCart();

    },

    modalCloseApp: () => {

      let close       = document.querySelector('.js-close-app');
      let modal       = document.querySelector('.close-confirm');
      let modalClose  = document.querySelectorAll('.close-modal');

      close.addEventListener('click', () => {
        modal.setAttribute('aria-hidden', false);
      });

      modalClose.forEach((close)=>{
        close.addEventListener('click', () => {
          modal.setAttribute('aria-hidden', true);
        });
      });

    },

    mobileCart: () => {

      let trigger   = document.querySelector('.configurator__rings__total svg');
      let cart      = document.querySelector('.configurator__rings__cart');
      let close     = document.querySelector('.configurator__rings__cart .close');

      if ( trigger ) {
        trigger.addEventListener('click', () => {
          cart.classList.toggle('active');
        });
      }

      if ( close ) {
        close.addEventListener('click', () => {
          cart.classList.remove('active');
        });
      }

    },

    productEvents: () => {

        let products        = document.querySelectorAll('.products__list__item');
        let mobileProducts  = document.querySelectorAll('[data-popup]');

        let undo            = document.querySelector('.configurator__rings__preview__nav--undo');
        let reset           = document.querySelector('.configurator__rings__preview__nav--reset');

        if ( undo ) {
            undo.addEventListener('click', () => {

                let items   = configuratorRings.settings.items;
                if (items.length > 0) {
                    const lastItem = items[items.length - 1];
                    if ( lastItem.quantity > 1 ) {
                        lastItem.quantity -= 1;
                    } else {
                        items.pop();
                    }

                    configuratorRings.renderCart();
                    configuratorRings.renderPreview();

                }
                
            });
        }

        if ( reset ) {
            reset.addEventListener('click', () => {
                configuratorRings.settings.items = [];
                configuratorRings.renderCart();
                configuratorRings.renderPreview();
            });
        }

        if ( products ) {

            [].forEach.call(products, (product) => {

                let button      = product.querySelectorAll('.Tooltip__List__Variant');

                if ( window.innerWidth > 1023 ) {
                    configuratorRings.createTooltip(product);
                } else {
                    // show product popup with size options
                }

                if ( button ) {
                    [].forEach.call(button, (btn) => {
                        btn.addEventListener('click', () => {    
                            configuratorRings.addProduct(product, btn.dataset.variant, btn.dataset.size);
                        });
                    });
                }

            });

        }

        if ( mobileProducts ) {

            let close       = document.querySelectorAll('.js-close-popup');

            [].forEach.call(mobileProducts, (product) => {

                let popup       = document.querySelector(`#${product.dataset.popup}`);
                let submit      = popup.querySelector('.product__item__popup__submit button');
                let options     = popup.querySelectorAll('.product__item__popup__size li');

                product.addEventListener('click', () => {
                    if ( popup ) {
                        popup.classList.add('active');
                    }
                });

                if ( options ) {
                    [].forEach.call(options, (option) => {
                        option.addEventListener('click', () => {

                            let selected = popup.querySelector('.product__item__popup__size li.selected');
                            if ( selected ) {
                                selected.classList.remove('selected');
                            }

                            option.classList.add('selected');
                            submit.removeAttribute('disabled');
                        });
                    });
                }

                if ( submit ) {
                    submit.addEventListener('click', () => {

                        let selected     = popup.querySelector('.product__item__popup__size li.selected')

                        if ( selected ) {

                            configuratorRings.addProduct(popup, selected.dataset.variant, selected.dataset.size);
                            popup.classList.remove('active');
                            window.scroll({
                                top: 0, 
                                left: 0, 
                                behavior: 'smooth' 
                            });
                        }
                        
                    });
                }

            });

            if ( close ) {
                [].forEach.call(close, (btn) => {
                    btn.addEventListener('click', () => {
                        let popup = btn.closest('.product__item__popup');
                        if ( popup ) {
                            popup.classList.remove('active');
                        }
                    });
                });
            }

        }

    },

    checkCartQuantity: () => {
        return configuratorRings.settings.items.reduce((acc, item) => acc + item.quantity, 0) < configuratorRings.settings.limit;
    },

    addProduct: (product, variant, size) => {
        document.dispatchEvent(new CustomEvent("theme:loading:start"));

        if ( configuratorRings.checkCartQuantity() ) {

            const existingItem = configuratorRings.settings.items.find((item) => item.variant === variant);

            if ( existingItem ) {
                existingItem.quantity += 1;
            } else {
                configuratorRings.settings.items.push({
                    variant: variant,
                    quantity: 1,
                    title: product.dataset.title,
                    price: product.dataset.price,
                    image: product.dataset.cartimage,
                    preview: product.dataset.preview,
                    size: size
                });
            }

            configuratorRings.renderCart();
            configuratorRings.renderPreview();

        }

        document.dispatchEvent(new CustomEvent("theme:loading:end"));

    },

    renderPreview: () => {

        let buttons             = document.querySelectorAll('.configurator__rings__preview__nav button');
        let items               = configuratorRings.settings.items;
        let holder              = document.querySelector('.configurator__rings__preview__inner');
            holder.innerHTML    = '';
            
        if ( items.length > 0 ) {
            
            let loopIndex           = 1;

            if ( buttons ) {
                buttons.forEach((button) => {
                    button.classList.remove('hidden');
                });
            }

            items.forEach((item) => {
                
                for (let i = 0; i < item.quantity; i++) {

                    let image       = document.createElement('img');
                        image.src   = item.preview;
                        image.setAttribute('alt', item.title);
                        image.setAttribute('style', `z-index: ${loopIndex}`);

                    holder.appendChild(image);
                    loopIndex++;
                }

            });
        } else {
            if ( buttons ) {
                buttons.forEach((button) => {
                    button.classList.add('hidden');
                });
            }
        }
    },

    renderCart: () => {

        let totalQuantity       = 0;
        let submitButton        = document.querySelector('.configurator__rings__total .add-to-cart');
        let holder              = document.querySelector('.configurator__rings__items');
            holder.innerHTML    = '';

        document.querySelector('.configurator__rings__main').classList.remove('limit-reached');

        if ( configuratorRings.settings.items.length > 0 ) {
            
            submitButton.removeAttribute('disabled');

            let items               = configuratorRings.settings.items;

            items.forEach((item, index) => {
                totalQuantity += item.quantity;
                holder.innerHTML += `<div class="cart-item" data-index="${index}">
                    <figure><img src="${item.image}" alt="${item.title}"></figure>
                    <div class="cart-item__details">
                        <div class="cart-item__remove">
                            <svg class="Icon Icon--close " viewBox="0 0 16.239 16.238">
                                <g id="Path_607" data-name="Path 607" transform="translate(-66.835 -72.18)" fill="none">
                                    <path d="M83.074,72.668l-.488-.488L74.955,79.81,67.324,72.18l-.488.488L74.466,80.3,66.836,87.93l.488.488,7.631-7.631,7.631,7.631.488-.488L75.443,80.3Z" stroke="none"></path>
                                    <path d="M 67.32398986816406 72.17959594726562 L 74.95474243164062 79.81034088134766 L 82.58547973632812 72.17959594726562 L 83.073974609375 72.66806030273438 L 75.44319915771484 80.29880523681641 L 83.073974609375 87.92957305908203 L 82.58547973632812 88.41802978515625 L 74.95474243164062 80.78726959228516 L 67.32398986816406 88.41802978515625 L 66.83551025390625 87.92957305908203 L 74.46628570556641 80.29880523681641 L 66.83551025390625 72.66806030273438 L 67.32398986816406 72.17959594726562 Z" stroke="none" fill="#000"></path>
                                </g>
                            </svg>
                        </div>
                        <h5>${item.title} - ${item.size}</h5>
                        <div class="cart-item__row">
                            <div class="cart-item__quantity">
                                <span>${window.quantity_label}</span>
                                <div class="QuantitySelector">
                                    <a class="QuantitySelector__Button Link Link--primary u-h7 font-light" data-quantity="${item.quantity - 1}" data-action="decrease-item-quantity">-
                                    </a>
                                    ${item.quantity}
                                    <a class="QuantitySelector__Button Link Link--primary u-h7 font-light" data-quantity="${item.quantity + 1}" data-action="increase-item-quantity">+
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>`;
            });

            if ( totalQuantity == configuratorRings.settings.limit ) {
                document.querySelector('.configurator__rings__main').classList.add('limit-reached');
            }

            let quantity_selectors  = document.querySelectorAll('.QuantitySelector__Button');
            let remove              = document.querySelectorAll('.cart-item__remove');

            if ( quantity_selectors ) {

                quantity_selectors.forEach((selector) => {
                    selector.addEventListener('click', () => {

                        let action = selector.getAttribute('data-action');
                        let quantity = parseInt(selector.getAttribute('data-quantity'));

                        if ( action === 'decrease-item-quantity' ) {
                            let index = parseInt(selector.closest('.cart-item').getAttribute('data-index'));
                            configuratorRings.settings.items[index].quantity = quantity;
                            configuratorRings.renderCart();
                            configuratorRings.renderPreview();
                        }

                        if ( action === 'increase-item-quantity' && configuratorRings.checkCartQuantity() ) {
                            let index = parseInt(selector.closest('.cart-item').getAttribute('data-index'));
                            configuratorRings.settings.items[index].quantity = quantity;
                            configuratorRings.renderCart();
                            configuratorRings.renderPreview();
                        }

                    });
                });

            }

            if ( remove ) {

                remove.forEach((button) => {
                    button.addEventListener('click', () => {

                        let index = parseInt(button.closest('.cart-item').getAttribute('data-index'));
                        configuratorRings.settings.items.splice(index, 1);
                        configuratorRings.renderCart();
                        configuratorRings.renderPreview();

                    });
                });

            }

        } else {
            submitButton.setAttribute('disabled', true);
        }

    },

    hashCode: () => {
      var hash = 0,
      i, chr;
      if (this.length === 0) return hash;
      for (i = 0; i < this.length; i++) {
        chr = this.charCodeAt(i);
        hash = ((hash << 5) - hash) + chr;
        hash |= 0;
      }
      return hash;
    },

    handleAddToCartButton: () => {

      let submitButton  = document.querySelector('.configurator__rings__total .add-to-cart');

      submitButton.addEventListener('click', () => {
        if ( submitButton.getAttribute('disabled') ) {
          return;
        }

        // Proceed with add to cart
        document.dispatchEvent(new CustomEvent("theme:loading:start"));

        if ( configuratorRings.settings.items.length > 0 ) {

            var cartItems = {
                items: configuratorRings.settings.items.map((item) => {
                    return {
                        id: item.variant,
                        quantity: item.quantity
                    }
                })
            }

            fetch(window.Shopify.routes.root + 'cart/add.js', {
                method: 'POST',
                body: JSON.stringify(cartItems),
                headers: {
                'Content-Type': 'application/json'
                },
            })
            .then((response) => response.json())
            .then((response) => {
                if ( response.items.length > 0 ) {
                    window.location.replace(routes.cartUrl);
                } else {
                    alert(response.message);
                }
            })
            .catch((e) => {
                console.error(e);
            })
            .finally(() => {
                document.dispatchEvent(new CustomEvent("theme:loading:end"));
            });

        }
        
      });

    },

    createTooltip(element) {

        const tooltipElement = element.querySelector(".Tooltip--main");
    
        if (!tooltipElement) return;
    
        const popperInstance = Popper.createPopper(
          element,
          tooltipElement,
          {
            placement: "right",
            offset: [0, 8],
          }
        );
    
        function show() {
          if (element.classList.contains("disabled")) return;
    
          tooltipElement.setAttribute("data-show", "");
          popperInstance.update();
        }
    
        function hide() {
          tooltipElement.removeAttribute("data-show");
        }
    
        const showEvents = ["mouseenter", "focus"];
        const hideEvents = ["mouseleave", "blur"];
    
        showEvents.forEach((event) => {
          element.addEventListener(event, show);
        });
    
        hideEvents.forEach((event) => {
          element.addEventListener(event, hide);
        });
    
        const observer = new MutationObserver((mutations) => {
          mutations.forEach((mutation) => {
            if (mutation.attributeName === "class") {
              if (element.classList.contains("disabled")) {
                hide();
              }
            }
          });
        });
    
        observer.observe(element, {
          attributes: true,
        });

    },

    initSwipers: () => {

      let swiperWrappers    = document.querySelector('.configurator__rings__products--mobile');
      let swipers           = swiperWrappers.querySelectorAll('.products__list .swiper');

      if ( swiperWrappers && swipers ) {
        [].forEach.call(swipers, (swiperInstance) => {
          const swiper = new Swiper(swiperInstance, {
            slidesPerView: 3,
            spaceBetween: 20,
            scrollbar: {
              el: '.swiper-scrollbar',
            },
          });
        })
      }

    }

}

configuratorRings.init();